import * as React from "react";
import type { SVGProps } from "react";
const SvgBell02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 20.63c.796.603 1.848.97 3 .97s2.204-.367 3-.97M3.571 17.527c-.474 0-.74-.706-.452-1.099.666-.91 1.308-2.247 1.308-3.855l.028-2.331C4.455 5.91 7.833 2.4 12 2.4c4.229 0 7.657 3.563 7.657 7.957l-.028 2.216c0 1.62.62 2.963 1.26 3.874.275.393.01 1.08-.459 1.08z"
    />
  </svg>
);
export default SvgBell02;
